export default __webpack_public_path__ + "static/media/treeEdit.61616cb8.svg";